/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 12/04/25
 */

import React from 'react';
import { Alert, AlertDescription, AlertIcon, Button } from '@chakra-ui/react';
import { useGetRequest } from '@/utils/useStatefulRequests';

const DownloadFile = ({ label, path }: { label: string; path: string }) => {
    const { makeRequest, loading, error } = useGetRequest<Blob>({ noCache: true });

    const _download = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        try {
            const response = await makeRequest(path, { responseType: 'blob' });

            if (response && response.data) {
                const url = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;

                const value = response.headers['content-disposition'] ?? response.headers['Content-Disposition'];

                if (value) {
                    const p = value.indexOf('filename=');

                    if (p > 0) {
                        link.download = value.substring(p + 'filename='.length + 1, value.length - 1).trim();
                    }
                }

                document.body.appendChild(link);
                link.click();

                setTimeout(() => {
                    URL.revokeObjectURL(url);
                    document.body.removeChild(link);
                }, 500);
            }
        } catch (e) {
            //handled by hook
        }
    };

    return (
        <>
            <Button onClick={_download} aria-label={label} colorScheme="blue" isLoading={loading}>
                {label}
            </Button>
            {error && (
                <Alert status="error">
                    <AlertIcon />
                    <AlertDescription>{`Failed download: ${error}`}</AlertDescription>
                </Alert>
            )}
        </>
    );
};

export default DownloadFile;
